













































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component({})
export default class Paging extends Vue {
    @Prop({default: 0})
    private intTotal!: number;
    @Prop({default: 0})
    private intCurrPage!: number;
    @Prop({default: 10})
    private intPageSize!: number;
    @Prop({default: 0})
    private intRowPerPage!: number;

    @Prop({default: 0})
    private intRowFrom!: number;
    @Prop({default: 0})
    private intRowTo!: number;
    @Prop({default: false})
    private showTotal!: boolean;

    @Prop({default: '#fff'})
    private bgColorPage!: string;

    private intPageNumber = 1;
    private i = 1;
    private intTotalPage = 0;
    private intStart = 0;
    private arrItem: any = [];
    private lstShowItem = [10, 20, 50, 100];

    get propChange() {
        return {
          intTotal: this.intTotal,
          intCurrPage: this.intCurrPage,
          intPageSize: this.intPageSize,
          intRowPerPage: this.intRowPerPage,
          intRowFrom: this.intRowFrom,
          intRowTo: this.intRowTo,
          showTotal: this.showTotal,
        };
    }

    @Watch('propChange', { immediate: true, deep: true })
    private onChangeProp() {
        this.loadData();
    }

    private loadData() {
        if (this.intCurrPage === 0) {
            this.intCurrPage = 1;
        }

        this.intRowPerPage = this.intRowPerPage === 0 ? 1 : this.intRowPerPage;

        if (this.intTotal % this.intRowPerPage > 0) {
            this.intTotalPage = Math.floor(this.intTotal / this.intRowPerPage) + 1;
        } else {
            this.intTotalPage = Math.floor(this.intTotal / this.intRowPerPage);
        }

        if (this.intRowTo > this.intTotal) {
            this.intRowTo = this.intTotal;
        }

        if (this.intCurrPage <= this.intTotalPage) {
        if (this.intCurrPage === 1) {
            this.intPageNumber = this.intPageSize;
            if (this.intPageNumber > this.intTotalPage) {
            this.intPageNumber = this.intTotalPage;
            }
            this.intStart = 1;
        } else {
            if (this.intTotalPage - this.intCurrPage < Math.floor(this.intPageSize / 2)) {
                this.intStart = this.intTotalPage - this.intPageSize + 1;
                if (this.intStart <= 0) {
                    this.intStart = 1;
                }
                this.intPageNumber = this.intTotalPage;
            } else {
                if (this.intCurrPage - Math.floor(this.intPageSize / 2) === 0) {
                    this.intStart = 1;
                    this.intPageNumber = this.intCurrPage + Math.floor(this.intPageSize / 2) + 1;
                    if (this.intTotalPage < this.intPageNumber) {
                        this.intPageNumber = this.intTotalPage;
                    }
                } else {
                    this.intStart = this.intCurrPage - Math.floor(this.intPageSize / 2);
                    if (this.intStart <= 0) {
                        this.intStart = 1;
                    }
                    this.intPageNumber = this.intCurrPage + Math.floor(this.intPageSize / 2);
                    if (this.intTotalPage < this.intPageNumber) {
                        this.intPageNumber = this.intTotalPage;
                    } else {
                        if (this.intPageNumber < this.intPageSize) {
                            this.intPageNumber = this.intPageSize;
                        }
                    }
                }
            }
        }
        this.i = this.intStart;

        this.createRange(this.i, this.intPageNumber);
    }
  }

  private createRange(index: any, numb: any) {
    this.arrItem = [];
    let iCountPage = 1;
    while (index <= numb && iCountPage <= this.intTotalPage) {
      this.arrItem.push(index);
      index++;
      iCountPage++;
    }
  }

  private eventClickPage(i: any) {
    if (i !== this.intCurrPage && i <= this.intTotalPage) {
      this.$emit('eventClickPage', i);
    }
  }

  private eventChangeShowItem(value: any) {
    if (value !== this.intPageSize) {
      this.$emit('eventChangeShowItem', value);
    }
  }
}
